/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserGlobalGrants } from '../fn/user-global-grants/get-user-global-grants';
import { GetUserGlobalGrants$Params } from '../fn/user-global-grants/get-user-global-grants';
import { updateUserGlobalGrants } from '../fn/user-global-grants/update-user-global-grants';
import { UpdateUserGlobalGrants$Params } from '../fn/user-global-grants/update-user-global-grants';
import { UserGlobalGrantsDto } from '../models/user-global-grants-dto';

@Injectable({ providedIn: 'root' })
export class GeneratedUserGlobalGrantsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserGlobalGrants()` */
  static readonly GetUserGlobalGrantsPath = '/api/users/{id}/global-grants';

  /**
   * Gets the global grants of a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserGlobalGrants()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserGlobalGrants$Response(params: GetUserGlobalGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalGrantsDto>> {
    return getUserGlobalGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets the global grants of a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserGlobalGrants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserGlobalGrants(params: GetUserGlobalGrants$Params, context?: HttpContext): Observable<UserGlobalGrantsDto> {
    return this.getUserGlobalGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGlobalGrantsDto>): UserGlobalGrantsDto => r.body)
    );
  }

  /** Path part for operation `updateUserGlobalGrants()` */
  static readonly UpdateUserGlobalGrantsPath = '/api/users/{id}/global-grants';

  /**
   * Gives a user exactly the given global grants.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateUserGlobalGrants()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserGlobalGrants$Response(params: UpdateUserGlobalGrants$Params, context?: HttpContext): Observable<StrictHttpResponse<UserGlobalGrantsDto>> {
    return updateUserGlobalGrants(this.http, this.rootUrl, params, context);
  }

  /**
   * Gives a user exactly the given global grants.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateUserGlobalGrants$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateUserGlobalGrants(params: UpdateUserGlobalGrants$Params, context?: HttpContext): Observable<UserGlobalGrantsDto> {
    return this.updateUserGlobalGrants$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserGlobalGrantsDto>): UserGlobalGrantsDto => r.body)
    );
  }

}
